import type { FixMe } from '@/types/globals'
import type { Container, CPComponentBaseConfiguration, ExtendedBlock, RepeatableContainer } from 'widget-components'

export type FlattenBlock = CPComponentBaseConfiguration & {
    children?: FlattenBlock[][]
    conditionIndexPath?: number[]
    currentValue?: FixMe
}

export const flattenBlocks = (blocks: ExtendedBlock[], parentConditionIndexPath: number[] = []): FixMe =>
    blocks.flatMap((block, index) => {
        if (['CONTAINER', 'TABBED_CONTAINER'].includes(block.type)) {
            return [block, ...flattenBlocks((block as Container).children ?? [])]
        }

        if (block.type === 'REPEATABLE_CONTAINER') {
            const iterations = (block as RepeatableContainer).children ?? []
            return [{
                ...block,
                conditionIndexPath: [...parentConditionIndexPath, index],
                children: iterations.map(iteration => flattenBlocks(iteration, [...parentConditionIndexPath, index])),
            } as FlattenBlock]
        }

        return [block as FlattenBlock]
    })

export type indexStack = { fieldName: string, index: number}[]

export const replaceNestedIndexKey = (condition: string, indexStack: indexStack) => {
    let result = condition

    for (const { fieldName, index } of indexStack) {
        const pattern = new RegExp(`${fieldName}\\[\\$\\$index\\]`, 'g')
        result = result.replace(pattern, `${fieldName}[${index}]`)
    }

    return result
}
